<div *ngIf="(total > limit && theme !=='socials-theme')" [ngClass]="{'dark-theme': theme === 'darkTheme'}" class="wrapper">

	<ng-container *ngIf="!theme">
		<a (click)="changePage(page-1)" [hidden]="toPage" [ngClass]="{disabled: loading || (page-1 <= 0) }"
			class="button previous">
			<i class="fa fa-chevron-left"></i><span><span class="label">{{ 'PREVIOUS' | translate }}</span></span>
		</a>
	</ng-container>
	<ng-container *ngIf="theme==='darkTheme'">
		<a (click)="changePage(page-1)" [hidden]="toPage" [ngClass]="{disabled: loading || (page-1 <= 0) }"
			class="previous">
			<i class="fa fa-arrow-circle-left"></i>
		</a>
	</ng-container>
	<ng-container *ngIf="!theme">
		<a (click)="changePage(page+1)" [hidden]="toPage"
			[ngClass]="{disabled: loading || (offset >= (total - limit)) }" class="button next">
			<i class="fa fa-chevron-right"></i><span><span class="label">{{ 'NEXT' | translate }}</span></span>
		</a>
	</ng-container>
	<ng-container *ngIf="theme==='darkTheme'">
		<a (click)="changePage(page+1)" [hidden]="toPage"
			[ngClass]="{disabled: loading || (offset >= (total - limit)) }" class="next">
			<i class="fa fa-arrow-circle-right"></i>
		</a>
	</ng-container>

	<a (click)="changePage(toPage)" [hidden]="!toPage" class="button go">
			<i class="fa fa-chevron-right"></i><span>{{ 'GO' | translate }}</span>
	</a>

	<input (keyup.enter)="changePage(toPage)" type="number" min="1" max="{{ pages[pages.length-1] }}"
			[(ngModel)]="toPage" [hidden]="pages.length <= 1" placeholder="{{ 'GO_TO_PAGE' | translate }}..."
			class="to-page" />

	<div class="pages">
		<ul class="socials-pages">
			<li class="socials-list" *ngFor="let pageInfo of pages | iterable">
				<span class="button disabled join-left join-right"
					*ngIf="pageInfo.key > 0 && (pages[pageInfo.key]-pages[pageInfo.key-1]) > 1">...</span>
				<a (click)="changePage(pageInfo.value)" class="button page"
					[ngClass]="{'active': page == pageInfo.value, 'join-left': pageInfo.key != 0 && theme !== 'socials-theme', 'join-right': pageInfo.key != pages.length-1 && theme !== 'socials-theme'}">{{ pageInfo.value }}</a>
			</li>
		</ul>

		<div class="results">
			<span *ngIf="loading">{{ 'LOADING' | translate | lowercase }}</span>
			<span *ngIf="!loading && total <= limit">{{ total }} {{ (total === 1 ? 'RESULT' : 'RESULTS') | translate
				}}</span>
			<span *ngIf="!loading && total > limit">
				{{ 'RESULT_COUNTER' | translate: {
				'start': (offset + 1),
				'end' : (offset + limit > total ? total : offset + limit),
				'total' : total
				} }}
			</span>
		</div>
	</div>
</div>

<div *ngIf="theme === 'socials-theme'" class="socials-theme wrapper">

	<div class="pages">
		<div class="row-limit">
			{{ 'ITEMS_PER_PAGE' | translate }}
			<bb-select class="limit" [(ngModel)]="limit" (change)="limitChanged.next(limit)" [options]="limitOptions"></bb-select>
		</div>

		<ng-container  >
			<div class="page-jumper" [ngStyle]="{'visibility' : (total < limit ? 'hidden' : 'visible') }">
				<label class="page-label">{{ 'JUMP_TO_PAGE' | translate }}</label>
				<input (keyup.enter)="changePage(toPage)" type="number" min="1" max="{{ pages[pages.length-1] }}"
					[(ngModel)]="toPage" [hidden]="pages.length <= 1" placeholder="..."
					class="to-page" />
			</div>
			<ul class="socials-pages"[ngStyle]="{'visibility' : (total < limit ? 'hidden' : 'visible') }">
				<a (click)="changePage(page-1)" [ngClass]="{disabled: loading || (page-1 <= 0) }"
					class="socials previous">
					<i class="fa-solid fa-chevron-left"></i>
				</a>

				<li class="socials-list" *ngFor="let pageInfo of pages | iterable">
					<span class="button disabled join-left join-right"
						*ngIf="pageInfo.key > 0 && (pages[pageInfo.key]-pages[pageInfo.key-1]) > 1">...</span>
					<a (click)="changePage(pageInfo.value)" class="button page"
						[ngClass]="{'active': page == pageInfo.value, 'join-left': pageInfo.key != 0 && theme !== 'socials-theme', 'join-right': pageInfo.key != pages.length-1 && theme !== 'socials-theme'}">{{ pageInfo.value }}</a>
				</li>

				<a (click)="changePage(page+1)" [ngClass]="{disabled: loading || (offset >= (total - limit)) }" class="socials next">
					<i class="fa-solid fa-chevron-right"></i>
				</a>
			</ul>
		</ng-container>

		<div class="results">
			<span *ngIf="loading">{{ 'LOADING' | translate | lowercase }}</span>
			<span *ngIf="!loading && total <= limit">{{ total }} {{ (total === 1 ? 'RESULT' : 'RESULTS') | translate
				}}</span>
			<span *ngIf="!loading && total > limit">
				{{ 'RESULT_COUNTER' | translate: {
				'start': (offset + 1),
				'end' : (offset + limit > total ? total : offset + limit),
				'total' : total
				} }}
			</span>
		</div>
	</div>
</div>